import { Badge, EventStatus, Icon } from '../../../shared/ui/Primitives';
import type { ExampleEvent } from '../adapters/demo-reader';

export function EventTable({
  events,
  selectedId,
  select,
  detail,
  recent = false,
}: {
  events: readonly ExampleEvent[];
  selectedId: string | undefined;
  select: (id: string) => void;
  detail: (event: ExampleEvent) => void;
  recent?: boolean;
}) {
  if (events.length === 0)
    return (
      <div className="p01-empty">
        <Icon name="empty" />
        <h3>当前筛选范围暂无事件</h3>
        <p>已成功读取 · 示范区域 · 全部事件 · 近7天</p>
      </div>
    );
  return (
    <table className={`p01-events ${recent ? 'p01-events-recent' : ''}`}>
      <caption className="p01-sr-only">
        {recent ? '近期事件' : '重点事件'} · 示例记录，选择事件可同步地图
      </caption>
      <thead>
        <tr>
          {(recent
            ? ['时间', '事件名称', '位置', '等级', '处置状态']
            : ['#', '事件名称', '位置', '事件类型', '处置状态', '发生时间']
          ).map((label) => (
            <th key={label} scope="col">
              {label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {events.map((event, index) => (
          <tr
            key={event.id}
            data-event-id={event.id}
            data-selected={selectedId === event.id}
            onClick={() => select(event.id)}
          >
            <td>{recent ? <time>{event.time}</time> : index + 1}</td>
            <td>
              <button aria-pressed={selectedId === event.id} onClick={() => select(event.id)}>
                {event.name}
              </button>
              <button
                className="p01-event-detail"
                aria-label={`查看详情：${event.name}`}
                onClick={(e) => {
                  e.stopPropagation();
                  select(event.id);
                  detail(event);
                }}
              >
                <Icon name="arrow" />
              </button>
            </td>
            <td>{event.location}</td>
            <td>
              {recent ? (
                <Badge tone={event.level === '高' ? 'red' : 'orange'}>{event.level}</Badge>
              ) : (
                event.type
              )}
            </td>
            <td>
              <EventStatus state={event.state} />
            </td>
            {!recent && (
              <td>
                <time>{event.time}</time>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
